import React from 'react';

import { AlineTooltip } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  // One reason per line, for a rule row whose chip stands for several position edits.
  reasons: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));

/**
 * Why the AI proposed a suggestion, shown over its chip, pill or strip. The
 * reason is the agent's own user-facing rationale, carried on every part of a
 * suggestion. A rule row's chip may stand for several position edits, so it
 * takes a list and shows one reason per line. With nothing to say the child
 * renders alone.
 */
export const SuggestionRationaleTooltip = React.memo(function SuggestionRationaleTooltip({
  children,
  rationales,
}: {
  children: React.ReactElement;
  rationales: readonly string[];
}): JSX.Element {
  const { classes } = useStyles();
  const reasons = rationales.map(rationale => rationale.trim()).filter(Boolean);
  if (reasons.length === 0) return children;

  return (
    <AlineTooltip
      arrow
      placement="top"
      title={
        <span className={classes.reasons}>
          {reasons.map((reason, index) => (
            <span key={index}>{reason}</span>
          ))}
        </span>
      }
    >
      {children}
    </AlineTooltip>
  );
});
